import { useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface HubSpotWaitlistModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: {
          region: string;
          portalId: string;
          formId: string;
          target: string;
        }) => void;
      };
    };
  }
}

export default function HubSpotWaitlistModal({ open, onOpenChange }: HubSpotWaitlistModalProps) {
  const formContainerRef = useRef<HTMLDivElement>(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (!open) return;

    const loadForm = () => {
      if (window.hbspt && formContainerRef.current) {
        formContainerRef.current.innerHTML = '';
        window.hbspt.forms.create({
          region: "na2",
          portalId: "244238638",
          formId: "5819f7ae-2af5-4ebd-b6c0-cc58434ed494",
          target: "#hubspot-form-container"
        });
      }
    };

    if (scriptLoadedRef.current && window.hbspt) {
      loadForm();
      return;
    }

    const existingScript = document.querySelector('script[src*="hsforms.net/forms/embed"]');
    if (existingScript) {
      scriptLoadedRef.current = true;
      loadForm();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://js-na2.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.onload = () => {
      scriptLoadedRef.current = true;
      loadForm();
    };
    document.head.appendChild(script);
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg md:max-w-xl">
        <DialogHeader>
          <DialogTitle>Join Our Waitlist</DialogTitle>
        </DialogHeader>
        <div 
          id="hubspot-form-container" 
          ref={formContainerRef} 
          className="min-h-[200px]" 
        />
      </DialogContent>
    </Dialog>
  );
}
